<template>
	<div></div>
</template>
<script>
	export default{
		mounted(){			
			this.$notify(this.$store.getters.notify);
		}
	}
</script>